import { IPivotStyleProps, IPivotStyles } from '@fluentui/react/lib/Pivot';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';

export function getPivotStyles(themeName: string, theme: ITheme) {
  return (props: IPivotStyleProps): Partial<IPivotStyles> => {
    const { rootIsTabs } = props;
    const { palette } = theme;

    let LINK_SELECTED_COLOR = palette.themePrimary;
    let LINK_COLOR = palette.neutralDark;

    if (themeName === 'contrast') {
      LINK_SELECTED_COLOR = palette.black;
      LINK_COLOR = palette.themeDark;
    }

    const commonStyles = {
      height: 60,
      lineHeight: 60,
      paddingTop: 3,
      marginRight: 0
    };
    const styles = {
      link: [
        { ...commonStyles },
        !rootIsTabs && {
          fontWeight: FontWeights.regular,
          color: LINK_COLOR,
          selectors: {
            ':hover': {
              color: LINK_COLOR,
              selectors: {
                ':before': {
                  background: palette.themeTertiary,
                  height: '3px'
                }
              }
            }
          }
        }
      ],
      linkIsSelected: [
        { ...commonStyles },
        !rootIsTabs && {
          color: LINK_SELECTED_COLOR,
          fontWeight: FontWeights.semibold,
          selectors: {
            ':hover': {
              color: LINK_SELECTED_COLOR
            },
            ':active': {
              color: LINK_SELECTED_COLOR
            },
            ':before': {
              border: 'none',
              height: '3px',
              background: palette.themePrimary
            }
          }
        }
      ]
    } as Partial<IPivotStyles>;

    return styles;
  };
}
